export default {
  en: {
    ADD: 'ADD',
    EDIT: 'EDIT',
    CANCEL: 'REVERT UNSAVED CHANGES',
    BULK_TAGS_TEXT: 'Bulk Tags:',
    ROUTER_TAG_SELECT_PH: 'Select a Tag',
    ROUTER_TAG_COMPARE_PH: 'Select an Operator',
    ROUTER_TAG_VALUE_PH: 'Enter the Tag Value',
    ROUTER_OPERATION_VALUE_PH: '0.00',
    ROUTER_FILTER_VALUE_PH: 'Select Filter Value',
    SELECT_FILTER: 'Select Filter',
    SEARCH_FILTER: 'Search Filter',
    INPUT_TAG: 'Enter the Tag Name',
    ADD_AFFILIATE_EDIT_PAYOUT_ACTIONS: 'Override Campaign Configuration Settings',
    BULK_MODIFIER_SELECT_PH: 'Select a Bulk Modifier List',
    SELECT_BULK_MODIFIER_BUTTON_TT: 'Upload a CSV or TXT file that contains one line for each adjustment. Each line must contain 1) the tag value that triggers the adjustment, 2) the value to adjust by, and 3) the operation to use. For example, “Insured,10,Add” means Ringba adds 10 to the base bid value if the tag value is “Insured”.',
    BULK_LIST_UPLOAD_SUCCESS_TOAST: 'The Bulk List has been uploaded successfully',
    OPERATION_OVERRIDE_FROM_TAG_PH: 'Enter bid Tag Name',
  }
};